import React, { memo } from 'react';
import { NoResultsImage } from 'barnyard/images';


const classPrefix = 'rCorporate--EmptyRule';

const EmptyRule = () => (
  <div className={classPrefix}>
    <NoResultsImage />
    <p>Select a rule type using the dropdown on the left</p>
  </div>
);

EmptyRule.propTypes = {

};

export default memo(EmptyRule);
